import React, { useRef, useEffect, useState } from 'react';
import ShowError from "../shared/ShowError";
import ShowConfirm from "../shared/ShowConfirm";
import { Dialog } from "primereact/dialog";
import { InputNumber } from "primereact/inputnumber";
import { InputText } from "primereact/inputtext";
import { FloatLabel } from "primereact/floatlabel";
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import { Skeleton } from 'primereact/skeleton';
import { Toast } from 'primereact/toast';
import GeneralDialogFooter from '../shared/GeneralDialogFooter';
import {config} from "../shared/config";
import * as util from '../shared/commons';
import axios from "axios";
import { Checkbox } from 'primereact/checkbox';
import SetDescribealbeScoreComments from './SetDescribealbeScoreComments';

const ScoreSave = ({ targetType, targetId, schoolClassDegree, onChange, onClose}) => {
    const [loading, setLoading] = useState(true);
    const [continualTest, setContinualTest] = useState(null);
    const [errorVisible, setErorVisible] = useState(false);
    const [errorMessage, setErrorMessage] = useState("");
    const [saving, setSaving] = useState(false);
    const [describealbeScoreCommentsVisible, setDescribealbeScoreCommentsVisible] = useState(false);
    const [positive, setPositive] = useState("");
    const [negative, setNegative] = useState("");
    const [recommend, setRecommend] = useState("");
    const [studentIndex, setStudentIndex] = useState(-1);
    const [studentName, setStudentName] = useState("");

    useEffect(() => {
      var params = {};
      var url = "";
      if(targetType == util.scoreTypes.ContinualTest){
        url = config.Server+`/school/teacher/continual-test/list`;
        params = {login:util.getTrustedUser(), lastIndex:0, pageSize:0, continualTestId:targetId, schoolClassId:"", courseId:"", monthInd:0};
      }
      if(url == "") return;

      setLoading(true);
      console.log("params is>", params);
      console.log("url is>", url);
      axios
          .post(url, params )
          .then(res => {
              var response = res.data;
              if(response.state === "ok"){
                  var ct = {...response.data[0]};
                  for(var i=0;i<ct.students.length;i++){
                    ct.students[i]["positiveComment"] = "";
                    ct.students[i]["negativeComment"] = "";
                    ct.students[i]["recommendation"] = "";
                  }
                  for(var i=0;i<ct.students.length;i++){
                    if(!ct.students[i].isRegistered) {
                        ct.students[i].isPresent = true;
                        ct.students[i].score = null;
                        ct.students[i]["scoreStr"] = "";
                    }
                    else{
                        if(ct.students[i].isPresent){
                            ct.students[i]["scoreStr"] = String(ct.students[i].score);
                            if(ct.students[i].score>util.describableScores.good){
                                ct.students[i]["positiveComment"] = ct.students[i]["positiveCommentVeryGood"];
                                ct.students[i]["negativeComment"] = ct.students[i]["negativeCommentVeryGood"];
                                ct.students[i]["recommendation"] = ct.students[i]["recommendationVeryGood"];
                            }
                            else if(ct.students[i].score>util.describableScores.acceptable){
                                ct.students[i]["positiveComment"] = ct.students[i]["positiveCommentGood"];
                                ct.students[i]["negativeComment"] = ct.students[i]["negativeCommentGood"];
                                ct.students[i]["recommendation"] = ct.students[i]["recommendationGood"];
                            }
                            else if(ct.students[i].score>util.describableScores.rejected){
                                ct.students[i]["positiveComment"] = ct.students[i]["positiveCommentAcceptable"];
                                ct.students[i]["negativeComment"] = ct.students[i]["negativeCommentAcceptable"];
                                ct.students[i]["recommendation"] = ct.students[i]["recommendationAcceptable"];
                            }
                            else {
                                ct.students[i]["positiveComment"] = ct.students[i]["positiveCommentRejected"];
                                ct.students[i]["negativeComment"] = ct.students[i]["negativeCommentRejected"];
                                ct.students[i]["recommendation"] = ct.students[i]["recommendationRejected"];
                            }
                        }
                        else{
                            ct.students[i]["scoreStr"] = "";
                        }
                    }
                  }
                  console.log(ct.students)
                  setContinualTest(ct);
                  
                  setLoading(false);
                  
              }
              else{
                  setErrorMessage(response.message);
                  setErorVisible(true);
                  //setLoading(false);
              }
          })
          .catch(error => {
              setErrorMessage(error.code + "," + error.message);
              setErorVisible(true);
              //setLoading(false);
          });
     
    }, []);

    const editDialogFooter = function(){
        return (
            <GeneralDialogFooter onOkClick={()=>{saveItem()}} onCancelClick={()=>{onClose()}} saving={saving} />
        )
    }
    const saveItem = function(){
      setSaving(true);
      var tmp = continualTest.students;
      var students = [];
      for(var i=0;i<tmp.length;i++){
        var hasScore = true;
        if(tmp[i].scoreStr == null) tmp[i].scoreStr = "";
        if(tmp[i].scoreStr == "") hasScore = false;
        if(!util.IsNumber(tmp[i].scoreStr)) hasScore = false;

        var isPresent = tmp[i].isPresent;
        var isRegistered = false;
        var score = 0;
        var positiveCommentVeryGood = "";
        var negativeCommentVeryGood = "";
        var recommendationVeryGood = "";
        var positiveCommentGood = "";
        var negativeCommentGood = "";
        var recommendationGood = "";
        var positiveCommentAcceptable = "";
        var negativeCommentAcceptable = "";
        var recommendationAcceptable = "";
        var positiveCommentRejected = "";
        var negativeCommentRejected = "";
        var recommendationRejected = "";
        if((schoolClassDegree >=1) && (schoolClassDegree <=6)){
            if(isPresent){
                if(hasScore){
                    score = parseFloat(tmp[i].scoreStr);
                    isRegistered = true;
                    if(score>util.describableScores.good){
                        positiveCommentVeryGood = tmp[i].positiveComment;
                        negativeCommentVeryGood = tmp[i].negativeComment;
                        recommendationVeryGood = tmp[i].recommendation;
                    }
                    else if(score>util.describableScores.acceptable){
                        positiveCommentGood = tmp[i].positiveComment;
                        negativeCommentGood = tmp[i].negativeComment;
                        recommendationGood = tmp[i].recommendation;
                    }
                    else if(score>util.describableScores.rejected){
                        positiveCommentAcceptable = tmp[i].positiveComment;
                        negativeCommentAcceptable = tmp[i].negativeComment;
                        recommendationAcceptable = tmp[i].recommendation;
                    }else{
                        positiveCommentRejected = tmp[i].positiveComment;
                        negativeCommentRejected = tmp[i].negativeComment;
                        recommendationRejected = tmp[i].recommendation;
                    }
                }
                else{
                    score = 0;
                    isRegistered = false;
                    positiveCommentVeryGood = "";
                    negativeCommentVeryGood = "";
                    recommendationVeryGood = "";
                    positiveCommentGood = "";
                    negativeCommentGood = "";
                    recommendationGood = "";
                    positiveCommentAcceptable = "";
                    negativeCommentAcceptable = "";
                    recommendationAcceptable = "";
                    positiveCommentRejected = "";
                    negativeCommentRejected = "";
                    recommendationRejected = "";
                }
            }
            else{
                score = 0;
                isRegistered = true;
                positiveCommentVeryGood = "";
                negativeCommentVeryGood = "";
                recommendationVeryGood = "";
                positiveCommentGood = "";
                negativeCommentGood = "";
                recommendationGood = "";
                positiveCommentAcceptable = "";
                negativeCommentAcceptable = "";
                recommendationAcceptable = "";
                positiveCommentRejected = "";
                negativeCommentRejected = "";
                recommendationRejected = "";
            }
        }
        else{
            if(hasScore) {
                if(parseFloat(tmp[i].scoreStr)>20){
                    setErrorMessage("نمره نمی تواند بیشتر از 20 باشد");
                    setErorVisible(true);
                    setSaving(false);
                    return;
                }
                score = parseFloat(tmp[i].scoreStr);
                isRegistered = true;
                isPresent = true;
            }
            else if(!isPresent){
                isRegistered = true;
            }

        }
        students.push({
            studentId:tmp[i].student.id, 
            isRegistered:isRegistered, 
            isPresent:isPresent, 
            score:score,
            positiveCommentVeryGood:positiveCommentVeryGood,
            negativeCommentVeryGood:negativeCommentVeryGood,
            recommendationVeryGood:recommendationVeryGood,
            positiveCommentGood:positiveCommentGood,
            negativeCommentGood:negativeCommentGood,
            recommendationGood:recommendationGood,
            positiveCommentAcceptable:positiveCommentAcceptable,
            negativeCommentAcceptable:negativeCommentAcceptable,
            recommendationAcceptable:recommendationAcceptable,
            positiveCommentRejected:positiveCommentRejected,
            negativeCommentRejected:negativeCommentRejected,
            recommendationRejected:recommendationRejected,
        });
      }
      var params = {};
      var url = "";
      if(targetType == util.scoreTypes.ContinualTest){
        url = config.Server+`/school/teacher/continual-test/save`;
        params = {login:util.getTrustedUser(), id:targetId, courseId:continualTest.course.id, schoolClassId:continualTest.schoolClass.id, testDate:continualTest.testDate, monthInd:continualTest.monthInd, comment:continualTest.comment, isAgent:false, isFinal:false, students:students};
      }
      if(url == "") {
        setSaving(false);
        return;
      }
      console.log("save param is>", params);
      console.log("save url is>", url);
      axios
          .post(url, params )
          .then(res => {
              var response = res.data;
              console.log("save response is>", response);
              if(response.state === "ok"){
                  onChange(targetType, targetId);
                  onClose();                  
                  setSaving(false);
              }
              else{
                  setErrorMessage(response.message);
                  setErorVisible(true);
                  setSaving(false);
              }
          })
          .catch(error => {
              setErrorMessage(error.code + "," + error.message);
              setErorVisible(true);
              setSaving(false);
          });
        
    }
    const onInputChange = function(e, index){
        var tmp = {...continualTest};
        var val = '';
        val = (e.target && e.target.value) || '';
        var v = val;
        if(v == null) v = "";
        tmp.students[index].scoreStr = v;
        setContinualTest(tmp);
    }
    const onCheckboxChange = (e, name, index) => {
        var tmp = {...continualTest};
        if(name == "isPresent"){
            tmp.students[index].isPresent = e.checked;
        }
        setContinualTest(tmp);
    }
    const onScoreCheckboxChange = (e, score, index) => {
        if(!continualTest.students[index].isPresent) return;
        var tmp = {...continualTest};
        tmp.students[index].scoreStr = String(score);
        tmp.students[index].score = score;
        setContinualTest(tmp);
    }
    const getCheckedState = function (index, target){
        if(!continualTest.students[index].isPresent) return false;
        var score = continualTest.students[index].score;
        if(score == 0) return false;
        if(target == 1){
            if(score == util.describableScores.veryGood)return true;
            else return false;
        }
        else if(target == 2){
            if((score==util.describableScores.good)) return true;
            else return false;
        }
        else if(target == 3){
            if((score==util.describableScores.acceptable)) return true;
            else return false;
        }
        else if(target == 4){
            if(score == util.describableScores.rejected) return true;
            else return false;
        }

        return false;
    }
    const onSetDescribleableScoreComments = function(index, positiveStr, negativeStr, recommendStr){
        var tmp = {...continualTest};
        tmp.students[index].positiveComment = positiveStr;
        tmp.students[index].negativeComment = negativeStr;
        tmp.students[index].recommendation = recommendStr;
        setContinualTest(tmp);
        setDescribealbeScoreCommentsVisible(false);
    }
    const showSetDescribleableScoreCommentsForm = function(index){
        var row = continualTest.students[index];
        setPositive(row.positiveComment.trim());
        setNegative(row.negativeComment.trim());
        setRecommend(row.recommendation.trim());
        setStudentIndex(index);
        setStudentName("[" + row.student.nationalId + "] " + row.student.firstname + " " + row.student.lastname);
        setDescribealbeScoreCommentsVisible(true);

    }
    const createScoreGetter = function(index){
        if((schoolClassDegree >=1) && (schoolClassDegree <=6)){
            var row = continualTest.students[index];
            var color = "#ee4444";
            if((row.positiveComment.trim() != "")||(row.negativeComment.trim() != "")||(row.recommendation.trim() != ""))color = "#44ee44";
            return(
                <>
                    <td style={{textAlign:"center", backgroundColor:(index%2==0?"#fff":"#f2f2f2"), padding:"5px", borderBottom:"1px solid #d0d0d0"}}>
                        <Checkbox onChange={(e)=>{onScoreCheckboxChange(e, util.describableScores.veryGood, index)}} checked={getCheckedState(index, 1)} />
                    </td>                
                    <td style={{textAlign:"center", backgroundColor:(index%2==0?"#fff":"#f2f2f2"), padding:"5px", borderBottom:"1px solid #d0d0d0"}}>
                        <Checkbox onChange={(e)=>{onScoreCheckboxChange(e, util.describableScores.good, index)}} checked={getCheckedState(index, 2)} />
                    </td>                
                    <td style={{textAlign:"center", backgroundColor:(index%2==0?"#fff":"#f2f2f2"), padding:"5px", borderBottom:"1px solid #d0d0d0"}}>
                        <Checkbox onChange={(e)=>{onScoreCheckboxChange(e, util.describableScores.acceptable, index)}} checked={getCheckedState(index, 3)} />
                    </td>                
                    <td style={{textAlign:"center", backgroundColor:(index%2==0?"#fff":"#f2f2f2"), padding:"5px", borderBottom:"1px solid #d0d0d0"}}>
                        <Checkbox onChange={(e)=>{onScoreCheckboxChange(e, util.describableScores.rejected, index)}} checked={getCheckedState(index, 4)} />
                    </td>                
                    <td style={{textAlign:"center", backgroundColor:(index%2==0?"#fff":"#f2f2f2"), padding:"5px", borderBottom:"1px solid #d0d0d0"}}>
                        <div onClick={()=>{showSetDescribleableScoreCommentsForm(index)}} style={{width:"20px", height:"20px", backgroundColor:color, borderRadius:"50%"}}></div>
                    </td>                
                </>
            )

        }
        else{
            return(
                <td style={{textAlign:"center", backgroundColor:(index%2==0?"#fff":"#f2f2f2"), padding:"5px", borderBottom:"1px solid #d0d0d0"}}>
                    <InputText keyfilter={"num"} value={continualTest.students[index].scoreStr} onChange={(e) => onInputChange(e, index)} maxLength={5} className="p-inputtext-lg" style={{width:"100%", textAlign:"center", direction:"ltr"}}/>
                </td>                
            )
        }
    }
    return (
        <>
        <Dialog visible={true} style={{ width: '50rem' }} breakpoints={{ '960px': '75vw', '641px': '90vw' }}
        header="ثبت نمره" modal className="p-fluid" footer={() => editDialogFooter()} onHide={() => onClose()}>
            {
                loading?
                <>
                    loding...
                    <br/>
                    <Skeleton />
                </>
                :
                <>
                    <table style={{width:"100%", borderCollapse:"collapse"}}>
                        <tbody>
                            <tr><td colSpan={2}>&nbsp;</td></tr>
                            <tr>
                                <td style={{padding:"3px",textAlign:"right", border:"1px solid #b0b0b0"}}>تاریخ: {util.SeperateDate(continualTest.testDate)}</td>
                                <td style={{padding:"3px",textAlign:"right", border:"1px solid #b0b0b0"}}>کلاس: {continualTest.schoolClass.name}</td>
                            </tr>
                            <tr>
                                <td style={{padding:"3px",textAlign:"right", border:"1px solid #b0b0b0"}}>ماه ثبتی: {util.getMonthName(continualTest.monthInd)}</td>
                                <td style={{padding:"3px",textAlign:"right", border:"1px solid #b0b0b0"}}>درس: {continualTest.course.name}</td>
                            </tr>
                            <tr><td colSpan={2}>&nbsp;</td></tr>
                        </tbody>
                    </table>

                    <table style={{width:"100%", borderCollapse:"collapse"}}>
                        <thead>
                            <tr style={{height:"100px"}}>
                                <th style={{width:"20px", backgroundColor:"#e5e5e5", fontWeight:"bold", padding:"5px", borderBottom:"1px solid #d0d0d0"}}>#</th>
                                <th style={{width:"100px", backgroundColor:"#e5e5e5", fontWeight:"bold", textAlign:"right", borderBottom:"1px solid #d0d0d0"}}>کد ملی</th>
                                <th style={{backgroundColor:"#e5e5e5", fontWeight:"bold", textAlign:"right", borderBottom:"1px solid #d0d0d0"}}>نام و نام خانوادگی</th>
                                <th style={{width:"35px", backgroundColor:"#e5e5e5", fontWeight:"bold", padding:"5px", borderBottom:"1px solid #d0d0d0", verticalAlign:"bottom"}}>
                                    حاضر
                                </th>
                                {
                                    ((schoolClassDegree >=1) && (schoolClassDegree <=6))?
                                    <>
                                    <th style={{width:"35px", backgroundColor:"#e5e5e5", fontWeight:"bold", padding:"5px", borderBottom:"1px solid #d0d0d0", verticalAlign:"bottom", position:"relative"}}>
                                        <div style={{transform:"rotate(270deg)", position:"absolute", top:"40px", left:"-30px", width:"90px", textAlign:"left"}}>خیلی خوب</div>                                    
                                    </th>
                                    <th style={{width:"35px", backgroundColor:"#e5e5e5", fontWeight:"bold", padding:"5px", borderBottom:"1px solid #d0d0d0", verticalAlign:"bottom", position:"relative"}}>
                                        <div style={{transform:"rotate(270deg)", position:"absolute", top:"40px", left:"-30px", width:"90px", textAlign:"left"}}>خوب</div>                                    
                                    </th>
                                    <th style={{width:"35px", backgroundColor:"#e5e5e5", fontWeight:"bold", padding:"5px", borderBottom:"1px solid #d0d0d0", verticalAlign:"bottom", position:"relative"}}>
                                        <div style={{transform:"rotate(270deg)", position:"absolute", top:"40px", left:"-30px", width:"90px", textAlign:"left"}}>قابل قبول</div>                                    
                                    </th>
                                    <th style={{width:"35px", backgroundColor:"#e5e5e5", fontWeight:"bold", padding:"5px", borderBottom:"1px solid #d0d0d0", verticalAlign:"bottom", position:"relative"}}>
                                        <div style={{transform:"rotate(270deg)", position:"absolute", top:"25px", left:"-45px", width:"120px", textAlign:"left"}}>نیاز به تلاش</div>                                    
                                    </th>
                                    <th style={{width:"35px", backgroundColor:"#e5e5e5", fontWeight:"bold", padding:"5px", borderBottom:"1px solid #d0d0d0", verticalAlign:"bottom", position:"relative"}}>
                                        <div style={{transform:"rotate(270deg)", position:"absolute", top:"40px", left:"-30px", width:"90px", textAlign:"left"}}>نظر</div>                                    
                                    </th>
                                    </>
                                    :
                                    <th style={{minWidth:"70px", width:((schoolClassDegree >=1) && (schoolClassDegree <=6))? "180px" :"90px", backgroundColor:"#e5e5e5", fontWeight:"bold", padding:"5px", borderBottom:"1px solid #d0d0d0", verticalAlign:"middle", textAlign:"center"}}>
                                        نمره
                                    </th>
                                }
                            </tr>
                        </thead>
                        <tbody>
                            {
                                continualTest.students.map((row, index)=>{
                                    return(
                                    <tr>
                                        <td style={{textAlign:"center", backgroundColor:(index%2==0?"#fff":"#f2f2f2"), fontWeight:"bold", padding:"5px", borderBottom:"1px solid #d0d0d0"}}>{(index+1)}</td>
                                        <td style={{backgroundColor:(index%2==0?"#fff":"#f2f2f2"), padding:"5px", borderBottom:"1px solid #d0d0d0"}}>{row.student.nationalId}</td>
                                        <td style={{backgroundColor:(index%2==0?"#fff":"#f2f2f2"), padding:"5px", borderBottom:"1px solid #d0d0d0"}}>{row.student.firstname + " " + row.student.lastname}</td>
                                        <td style={{textAlign:"center", backgroundColor:(index%2==0?"#fff":"#f2f2f2"), padding:"5px", borderBottom:"1px solid #d0d0d0"}}>
                                            <Checkbox onChange={(e)=>{onCheckboxChange(e, "isPresent", index)}} checked={continualTest.students[index].isPresent} />
                                        </td>
                                        {createScoreGetter(index)}
                                    </tr>
                                    )
                                })
                            }
                            <tr><td colSpan={5}>&nbsp;</td></tr>
                        </tbody>
                    </table>

                </>
            }

        </Dialog>
        {
        describealbeScoreCommentsVisible?
        <SetDescribealbeScoreComments onAccept={(index, positiveStr, negativeStr, recommendStr)=>{onSetDescribleableScoreComments(index, positiveStr, negativeStr, recommendStr)}} index={studentIndex} studentName={studentName} positiveComment={positive} negativeComment={negative} recommendation={recommend} onClose={()=>{setDescribealbeScoreCommentsVisible(false)}} />
        :
        <></>
        }
        </>
    )
};

export default ScoreSave;
